import { DownloadOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Space, Tabs } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import * as React from "react";
import { useEffect, useState } from "react";
import Link from "react-dom";
import { useParams } from "react-router";
import { GuestLayout } from "../../components/layout/guest-layout";
import "./orderlist.css";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const POST = async (path, data, header) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.post(
      `/${path}`,
      data,
      header ? header : config,
    );
    // console.log(config);
    data = await response.data;
    // console.log(response.data)
    return data;
  } catch (error) {
    // console.log(error.response);
    throw error.response;
  }
};
export default function Orderlist() {
  const { phone_cust } = useParams();

  const mode = new URLSearchParams(window.location.search).get("mode");

  const goline = () => {
    window.open(
      "https://page.line.me/wif8109n?oat__id=1190551&openQrModal=true",
    );
  };

  const goPath = () => {
    // console.log('test');
    window.location = `/register-warranty/add_products/${phone_cust}?mode=${mode}`;
  };

  const [dataorderhead, setdataorderhead] = useState([]);
  const [datapurchase, setdatapurchase] = useState([]);
  const [dataorderline, setdataorderline] = useState({
    data: [],
    sku: [],
  });
  const [namecust, setnamecust] = useState("");

  const { TabPane } = Tabs;

  useEffect(() => {
    if (Cookies.get("phone") != phone_cust) {
      Cookies.remove("jwt");
      Cookies.remove("phone");
      window.location = "/register-warranty/login";
    }
    // Define your API post request here
    const postData = async () => {
      try {
        const purchase = await POST("get_purchase/", {
          cust_phone_number: phone_cust,
        });
        if (purchase) {
          // console.log(purchase);
          setdatapurchase(purchase);
        }

        const response = await POST("save_and_show_head/", {
          cust_phone_number: phone_cust,
        });
        if (response) {
          const getname = await POST("get_cust_name/", {
            cust_phone_number: phone_cust,
          });
          if (getname) {
            setnamecust(getname[0].cust_fullname);
          }

          //     console.log(response.data[0].SavedData);
          //     const order_head = await axios.post('http://localhost:8080/warranty/get_order_num/', { cust_phone_number: phone_cust });
          //     console.log(order_head.data[0]);
          //     if (order_head.data) {
          setdataorderline({
            ...dataorderline,
            data: response,
          });
          // setdataorderline(prevState => ({
          //       ...prevState,
          //       data: [...prevState.data, response.data]
          // }));
          setdataorderhead(response);
          // setnamecust(response[0].cust_fullname);
          // handlePostAllOrders();
        }

        //   }
      } catch (error) {
        console.error(error);
      }
    };

    // Call the postData function when the Home component is rendered
    postData();
  }, []);

  useEffect(() => {
    if (dataorderhead) {
      handlePostAllOrders();
    }
  }, [dataorderhead]);

  const postOrder = async () => {
    try {
      dataorderhead.forEach(async (order) => {
        const order_line = await POST("save_and_show_line/", {
          order_number: order.order_number,
        });
        console.log(order_line);
        let line;

        if (order_line[0].length > 0) {
          line = order_line[0];
          setdataorderline((prevState) => ({
            ...prevState,
            sku: [...prevState.sku, line],
          }));
        } else {
          if (order_line[0][0] === undefined) {
            line = order_line[0];
          } else if (typeof order_line[0][0] === "object") {
            line = order_line[0][0];
          }
          setdataorderline((prevState) => ({
            ...prevState,
            sku: [...prevState.sku, line],
          }));
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (dataorderline) {
    }
  }, [dataorderline]);

  const handlePostAllOrders = () => {
    postOrder();
  };

  const [mappedData, setMappedData] = useState([]);

  const [size, setSize] = useState("middle");

  const getCardWidth = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 280) {
      return 270;
    } else if (screenWidth > 280 && screenWidth < 768) {
      return 330;
    } else {
      return 600;
    }
  };

  const [cardWidth, setCardWidth] = useState(getCardWidth());

  useEffect(() => {
    const handleResize = () => {
      setCardWidth(getCardWidth());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const maptab = dataorderline.sku.map((skuArr) => {
      let order_number = "";
      const test = skuArr.map((t, indexsku) => {
        order_number = t.order_number;
        const items = [];
        for (let i = 0; i < t.qty; i++) {
          items.push(
            <p key={`${indexsku}-${i}`}>
              <b>
                {indexsku + 1}. {t.item_name}
              </b>{" "}
              <br />
              <b>วันที่หมดประกัน:</b> {t.end_warranty_date} <br />
              {t.status === "อยู่ในประกัน (Warranty Active)" && (
                <div style={{ color: "green" }}>
                  <b>สถานะ:</b> {t.status}
                </div>
              )}
              {t.status === "หมดประกัน (Warranty Expired)" && (
                <div style={{ color: "red" }}>
                  <b>สถานะ:</b> {t.status}
                </div>
              )}
              {t.status !== "อยู่ในประกัน (Warranty Active)" &&
                t.status !== "หมดประกัน (Warranty Expired)" && (
                  <div style={{ color: "yellow" }}>
                    <u>{t.status}</u>
                  </div>
                )}
            </p>,
          );
        }
        return items;
      });
      return { order_number: order_number, card: test };
    });
    setMappedData(maptab);
  }, [dataorderline.sku]);

  return (
    <GuestLayout title={"ข้อมูลการรับประกันสินค้า"}>
      <div className="Content">
        <div className="Head" style={{ marginTop: "-2rem" }}>
          <h2>ข้อมูลการรับประกันสินค้า</h2>
          <h4>คุณ: {namecust}</h4>
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              paddingBottom: "20px",
            }}
          >
            <Button
              icon={<PlusOutlined />}
              size={size}
              onClick={() => {
                goPath();
              }}
            >
              เพิ่มข้อมูลใหม่ (Add New)
            </Button>
          </div>
        </div>
        <div className="Bodycontent">
          {datapurchase.map((e, index) => (
            <Card
              style={{
                width: `${cardWidth}px`,
                marginBottom: "15px",
              }}
              title={"เลขคำสั่งซื้อ: " + e.purc_receipt_id}
              actions={[
                <Button
                  style={{
                    background: "#30b4ac",
                    color: "white",
                  }}
                  onClick={goline}
                >
                  ติดต่อสอบถาม
                </Button>,
              ]}
            >
              <div defaultActiveKey={e.purc_receipt_id}>
                <div
                  key={e.purc_receipt_id}
                  style={{
                    width: "100%",
                    marginTop: "-20px",
                    marginBottom: "-30px",
                  }}
                >
                  <div>
                    <p>
                      <b>วันที่ซื้อ:</b> {e.date_add}{" "}
                    </p>
                    <p>
                      <b>ช่องทางที่ซื้อ:</b> {e.purc_channel}
                    </p>
                    <div style={{ color: "orange" }}>
                      <p>
                        <b>สถานะ:</b> {e.status}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
          {dataorderline.data.map((e, index) => (
            <Card
              style={{
                width: `${cardWidth}px`,
                marginBottom: "15px",
              }}
              title={"เลขคำสั่งซื้อ: " + e.order_number}
            >
              <Tabs
                defaultActiveKey={e.order_number}
                style={{
                  width: "100%",
                  marginTop: "-25px",
                }}
              >
                <TabPane
                  tab="Overview"
                  key={e.order_number}
                  style={{
                    width: "100%",
                    marginTop: "-15px",
                    marginBottom: "-20px",
                  }}
                >
                  <div>
                    <p>
                      <b>วันที่ซื้อ:</b> {e.purchase_date}{" "}
                    </p>
                    <p>
                      <b>ช่องทางที่ซื้อ:</b> {e.purchase_channel}
                    </p>
                    <p>
                      <b>สถานะ:</b> ยืนยันแล้ว
                    </p>
                  </div>
                </TabPane>
                {mappedData.filter(
                  (item) => item.order_number == e.order_number,
                ).length > 0 && (
                  <TabPane
                    tab="Warranty Details"
                    key={`${e.ordernumber}${e.ordernumber}`}
                  >
                    {
                      mappedData.filter(
                        (item) => item.order_number == e.order_number,
                      )[0].card
                    }
                  </TabPane>
                )}
              </Tabs>
            </Card>
          ))}
        </div>
      </div>
    </GuestLayout>
  );
}
